module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" Simple Line Icons\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user icons font-2xl d-block mt-4"
  }), _vm._v("icon-user\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-people icons font-2xl d-block mt-4"
  }), _vm._v("icon-people\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-female icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-female\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-follow icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-follow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-following icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-following\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-user-unfollow icons font-2xl d-block mt-4"
  }), _vm._v("icon-user-unfollow\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-login icons font-2xl d-block mt-4"
  }), _vm._v("icon-login\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-logout icons font-2xl d-block mt-4"
  }), _vm._v("icon-logout\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-emotsmile icons font-2xl d-block mt-4"
  }), _vm._v("icon-emotsmile\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-phone icons font-2xl d-block mt-4"
  }), _vm._v("icon-phone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-call-end icons font-2xl d-block mt-4"
  }), _vm._v("icon-call-end\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-call-in icons font-2xl d-block mt-4"
  }), _vm._v("icon-call-in\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-call-out icons font-2xl d-block mt-4"
  }), _vm._v("icon-call-out\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-map icons font-2xl d-block mt-4"
  }), _vm._v("icon-map\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-location-pin icons font-2xl d-block mt-4"
  }), _vm._v("icon-location-pin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-direction icons font-2xl d-block mt-4"
  }), _vm._v("icon-direction\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-directions icons font-2xl d-block mt-4"
  }), _vm._v("icon-directions\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-compass icons font-2xl d-block mt-4"
  }), _vm._v("icon-compass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-layers icons font-2xl d-block mt-4"
  }), _vm._v("icon-layers\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-menu icons font-2xl d-block mt-4"
  }), _vm._v("icon-menu\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-list icons font-2xl d-block mt-4"
  }), _vm._v("icon-list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-options-vertical icons font-2xl d-block mt-4"
  }), _vm._v("icon-options-vertical\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-options icons font-2xl d-block mt-4"
  }), _vm._v("icon-options\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-down icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-down\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-left icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-left\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-right icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-right\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-up icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-up\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-up-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-up-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-left-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-left-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-right-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-right-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-arrow-down-circle icons font-2xl d-block mt-4"
  }), _vm._v("icon-arrow-down-circle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-check icons font-2xl d-block mt-4"
  }), _vm._v("icon-check\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-clock icons font-2xl d-block mt-4"
  }), _vm._v("icon-clock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-plus icons font-2xl d-block mt-4"
  }), _vm._v("icon-plus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-close icons font-2xl d-block mt-4"
  }), _vm._v("icon-close\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-trophy icons font-2xl d-block mt-4"
  }), _vm._v("icon-trophy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-screen-smartphone icons font-2xl d-block mt-4"
  }), _vm._v("icon-screen-smartphone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-screen-desktop icons font-2xl d-block mt-4"
  }), _vm._v("icon-screen-desktop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-plane icons font-2xl d-block mt-4"
  }), _vm._v("icon-plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-notebook icons font-2xl d-block mt-4"
  }), _vm._v("icon-notebook\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-mustache icons font-2xl d-block mt-4"
  }), _vm._v("icon-mustache\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-mouse icons font-2xl d-block mt-4"
  }), _vm._v("icon-mouse\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnet icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-energy icons font-2xl d-block mt-4"
  }), _vm._v("icon-energy\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-disc icons font-2xl d-block mt-4"
  }), _vm._v("icon-disc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cursor icons font-2xl d-block mt-4"
  }), _vm._v("icon-cursor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cursor-move icons font-2xl d-block mt-4"
  }), _vm._v("icon-cursor-move\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-crop icons font-2xl d-block mt-4"
  }), _vm._v("icon-crop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-chemistry icons font-2xl d-block mt-4"
  }), _vm._v("icon-chemistry\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-speedometer icons font-2xl d-block mt-4"
  }), _vm._v("icon-speedometer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-shield icons font-2xl d-block mt-4"
  }), _vm._v("icon-shield\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-screen-tablet icons font-2xl d-block mt-4"
  }), _vm._v("icon-screen-tablet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magic-wand icons font-2xl d-block mt-4"
  }), _vm._v("icon-magic-wand\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-hourglass icons font-2xl d-block mt-4"
  }), _vm._v("icon-hourglass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-graduation icons font-2xl d-block mt-4"
  }), _vm._v("icon-graduation\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-ghost icons font-2xl d-block mt-4"
  }), _vm._v("icon-ghost\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-game-controller icons font-2xl d-block mt-4"
  }), _vm._v("icon-game-controller\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-fire icons font-2xl d-block mt-4"
  }), _vm._v("icon-fire\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-eyeglass icons font-2xl d-block mt-4"
  }), _vm._v("icon-eyeglass\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-envelope-open icons font-2xl d-block mt-4"
  }), _vm._v("icon-envelope-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-envelope-letter icons font-2xl d-block mt-4"
  }), _vm._v("icon-envelope-letter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bell icons font-2xl d-block mt-4"
  }), _vm._v("icon-bell\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-badge icons font-2xl d-block mt-4"
  }), _vm._v("icon-badge\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-anchor icons font-2xl d-block mt-4"
  }), _vm._v("icon-anchor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-wallet icons font-2xl d-block mt-4"
  }), _vm._v("icon-wallet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-vector icons font-2xl d-block mt-4"
  }), _vm._v("icon-vector\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-speech icons font-2xl d-block mt-4"
  }), _vm._v("icon-speech\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-puzzle icons font-2xl d-block mt-4"
  }), _vm._v("icon-puzzle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-printer icons font-2xl d-block mt-4"
  }), _vm._v("icon-printer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-present icons font-2xl d-block mt-4"
  }), _vm._v("icon-present\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-playlist icons font-2xl d-block mt-4"
  }), _vm._v("icon-playlist\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-pin icons font-2xl d-block mt-4"
  }), _vm._v("icon-pin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-picture icons font-2xl d-block mt-4"
  }), _vm._v("icon-picture\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-handbag icons font-2xl d-block mt-4"
  }), _vm._v("icon-handbag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-globe-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-globe-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-globe icons font-2xl d-block mt-4"
  }), _vm._v("icon-globe\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-folder-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-folder-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-folder icons font-2xl d-block mt-4"
  }), _vm._v("icon-folder\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-film icons font-2xl d-block mt-4"
  }), _vm._v("icon-film\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-feed icons font-2xl d-block mt-4"
  }), _vm._v("icon-feed\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-drop icons font-2xl d-block mt-4"
  }), _vm._v("icon-drop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-drawer icons font-2xl d-block mt-4"
  }), _vm._v("icon-drawer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-docs icons font-2xl d-block mt-4"
  }), _vm._v("icon-docs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-doc icons font-2xl d-block mt-4"
  }), _vm._v("icon-doc\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-diamond icons font-2xl d-block mt-4"
  }), _vm._v("icon-diamond\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cup icons font-2xl d-block mt-4"
  }), _vm._v("icon-cup\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-calculator icons font-2xl d-block mt-4"
  }), _vm._v("icon-calculator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bubbles icons font-2xl d-block mt-4"
  }), _vm._v("icon-bubbles\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-briefcase icons font-2xl d-block mt-4"
  }), _vm._v("icon-briefcase\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-book-open icons font-2xl d-block mt-4"
  }), _vm._v("icon-book-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-basket-loaded icons font-2xl d-block mt-4"
  }), _vm._v("icon-basket-loaded\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-basket icons font-2xl d-block mt-4"
  }), _vm._v("icon-basket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bag icons font-2xl d-block mt-4"
  }), _vm._v("icon-bag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-action-undo icons font-2xl d-block mt-4"
  }), _vm._v("icon-action-undo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-action-redo icons font-2xl d-block mt-4"
  }), _vm._v("icon-action-redo\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-wrench icons font-2xl d-block mt-4"
  }), _vm._v("icon-wrench\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-umbrella icons font-2xl d-block mt-4"
  }), _vm._v("icon-umbrella\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-trash icons font-2xl d-block mt-4"
  }), _vm._v("icon-trash\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-tag icons font-2xl d-block mt-4"
  }), _vm._v("icon-tag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-support icons font-2xl d-block mt-4"
  }), _vm._v("icon-support\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-frame icons font-2xl d-block mt-4"
  }), _vm._v("icon-frame\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-size-fullscreen icons font-2xl d-block mt-4"
  }), _vm._v("icon-size-fullscreen\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-size-actual icons font-2xl d-block mt-4"
  }), _vm._v("icon-size-actual\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-shuffle icons font-2xl d-block mt-4"
  }), _vm._v("icon-shuffle\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-share-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-share-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-share icons font-2xl d-block mt-4"
  }), _vm._v("icon-share\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-rocket icons font-2xl d-block mt-4"
  }), _vm._v("icon-rocket\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-question icons font-2xl d-block mt-4"
  }), _vm._v("icon-question\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-pie-chart icons font-2xl d-block mt-4"
  }), _vm._v("icon-pie-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-pencil icons font-2xl d-block mt-4"
  }), _vm._v("icon-pencil\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-note icons font-2xl d-block mt-4"
  }), _vm._v("icon-note\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-loop icons font-2xl d-block mt-4"
  }), _vm._v("icon-loop\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-home icons font-2xl d-block mt-4"
  }), _vm._v("icon-home\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-grid icons font-2xl d-block mt-4"
  }), _vm._v("icon-grid\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-graph icons font-2xl d-block mt-4"
  }), _vm._v("icon-graph\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-microphone icons font-2xl d-block mt-4"
  }), _vm._v("icon-microphone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-music-tone-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-music-tone-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-music-tone icons font-2xl d-block mt-4"
  }), _vm._v("icon-music-tone\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-earphones-alt icons font-2xl d-block mt-4"
  }), _vm._v("icon-earphones-alt\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-earphones icons font-2xl d-block mt-4"
  }), _vm._v("icon-earphones\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-equalizer icons font-2xl d-block mt-4"
  }), _vm._v("icon-equalizer\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-like icons font-2xl d-block mt-4"
  }), _vm._v("icon-like\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-dislike icons font-2xl d-block mt-4"
  }), _vm._v("icon-dislike\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-start icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-start\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-rewind icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-rewind\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-play icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-play\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-pause icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-pause\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-forward icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-forward\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-control-end icons font-2xl d-block mt-4"
  }), _vm._v("icon-control-end\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-volume-1 icons font-2xl d-block mt-4"
  }), _vm._v("icon-volume-1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-volume-2 icons font-2xl d-block mt-4"
  }), _vm._v("icon-volume-2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-volume-off icons font-2xl d-block mt-4"
  }), _vm._v("icon-volume-off\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-calendar icons font-2xl d-block mt-4"
  }), _vm._v("icon-calendar\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bulb icons font-2xl d-block mt-4"
  }), _vm._v("icon-bulb\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-chart icons font-2xl d-block mt-4"
  }), _vm._v("icon-chart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-ban icons font-2xl d-block mt-4"
  }), _vm._v("icon-ban\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-bubble icons font-2xl d-block mt-4"
  }), _vm._v("icon-bubble\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-camrecorder icons font-2xl d-block mt-4"
  }), _vm._v("icon-camrecorder\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-camera icons font-2xl d-block mt-4"
  }), _vm._v("icon-camera\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cloud-download icons font-2xl d-block mt-4"
  }), _vm._v("icon-cloud-download\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-cloud-upload icons font-2xl d-block mt-4"
  }), _vm._v("icon-cloud-upload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-envelope icons font-2xl d-block mt-4"
  }), _vm._v("icon-envelope\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-eye icons font-2xl d-block mt-4"
  }), _vm._v("icon-eye\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-flag icons font-2xl d-block mt-4"
  }), _vm._v("icon-flag\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-heart icons font-2xl d-block mt-4"
  }), _vm._v("icon-heart\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-info icons font-2xl d-block mt-4"
  }), _vm._v("icon-info\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-key icons font-2xl d-block mt-4"
  }), _vm._v("icon-key\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-link icons font-2xl d-block mt-4"
  }), _vm._v("icon-link\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-lock icons font-2xl d-block mt-4"
  }), _vm._v("icon-lock\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-lock-open icons font-2xl d-block mt-4"
  }), _vm._v("icon-lock-open\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnifier icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnifier\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnifier-add icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnifier-add\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-magnifier-remove icons font-2xl d-block mt-4"
  }), _vm._v("icon-magnifier-remove\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-paper-clip icons font-2xl d-block mt-4"
  }), _vm._v("icon-paper-clip\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-paper-plane icons font-2xl d-block mt-4"
  }), _vm._v("icon-paper-plane\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-power icons font-2xl d-block mt-4"
  }), _vm._v("icon-power\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-refresh icons font-2xl d-block mt-4"
  }), _vm._v("icon-refresh\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-reload icons font-2xl d-block mt-4"
  }), _vm._v("icon-reload\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-settings icons font-2xl d-block mt-4"
  }), _vm._v("icon-settings\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-star icons font-2xl d-block mt-4"
  }), _vm._v("icon-star\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-symbol-female icons font-2xl d-block mt-4"
  }), _vm._v("icon-symbol-female\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-symbol-male icons font-2xl d-block mt-4"
  }), _vm._v("icon-symbol-male\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-target icons font-2xl d-block mt-4"
  }), _vm._v("icon-target\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-credit-card icons font-2xl d-block mt-4"
  }), _vm._v("icon-credit-card\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-paypal icons font-2xl d-block mt-4"
  }), _vm._v("icon-paypal\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-tumblr icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-tumblr\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-twitter icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-twitter\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-facebook icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-facebook\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-instagram icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-instagram\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-linkedin icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-linkedin\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-pinterest icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-pinterest\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-github icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-github\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-gplus icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-gplus\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-reddit icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-reddit\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-skype icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-skype\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-dribbble icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-dribbble\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-behance icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-behance\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-foursqare icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-foursqare\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-soundcloud icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-soundcloud\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-spotify icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-spotify\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-stumbleupon icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-stumbleupon\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-youtube icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-youtube\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-4 col-md-3"
  }, [_c('i', {
    staticClass: "icon-social-dropbox icons font-2xl d-block mt-4"
  }), _vm._v("icon-social-dropbox\n        ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42df62d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coreui/icons/SimpleLineIcons.vue
// module id = 1002
// module chunks = 1